{
  "version": 1,
  "asset_id": "dadbb215-f67f-4b9a-b2f1-4a3271a65713",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/dadbb215-f67f-4b9a-b2f1-4a3271a65713/ss01-card-p5.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/dadbb215-f67f-4b9a-b2f1-4a3271a65713/ss01-card-p5.webp",
  "original_filename": "ss01-card-p5.webp",
  "size": 174486,
  "content_type": "image/webp",
  "created_at": "2026-09-12T16:22:56Z"
}
